import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum, UIDAStructureTypeEnum } from '@kaltura-ott/tvpil';

export class PersonalLineupStore {
  referenceId: string;
  subtype = UIDAPresentationTypeEnum.top_shelf_carousel;
  type = UIDAStructureTypeEnum.subpage;

  constructor(categoryTree: KuxFilteredCategoriesDTO) {
    this.referenceId = categoryTree.referenceId;
  }
}
